export const tableActionTypes = {
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
  DETAIL_VIEW: 'detailView',
};
